// this.$i18n.locale = 'zh'; // 切换到中文
import { createI18n } from 'vue-i18n';
import { fetchLocaleMessages } from '@/locales/locales';
import {store} from '@/store/store';

// 定义语言包
const messages = {
    en: {
        welcome: 'Welcome',
        greeting: 'Hello, {name}!',
    },
    zh: {
        welcome: '欢迎',
        greeting: '你好, {name}!',
    },
};


// 创建 i18n 实例
const i18n = createI18n({
    locale: store.state.locale, // 设置地区,默认语言
    fallbackLocale: store.state.locale, // 回退语言
    messages:messages, // 初始为空，动态加载
    // messages, // 设置地区信息,语言包
});

const loadedLocales = new Set();

async function loadLocaleMessages(locale) {
    if (loadedLocales.has(locale)) {
        store.commit('setLocaleLoaded', true); // 标记为已加载
        return locale;
    }

    const messages = await fetchLocaleMessages(locale);
    if (messages) {
        i18n.global.setLocaleMessage(locale, messages);
        loadedLocales.add(locale);
        store.commit('setLocaleLoaded', true); // 标记为已加载
    }

    return locale;
}

// 加载默认语言包
 loadLocaleMessages(i18n.global.locale);

export {
    i18n,
    loadLocaleMessages
}